import * as React from "react"
import {Link} from "gatsby"
import styled from "styled-components"
// import {FaBars} from 'react-icons/fa'
import {menuData} from '../data/menu-data'
import Logo from '../assets/light-logo.png'
import {Button} from "./button"

const Header = () => {
  return (
    <Nav>
      <NavLink to="/"><img src={Logo} alt="logo" width="95px" /></NavLink>
      {/* <MobileNavMenu>
        <NavLink to="/faq">FAQ</NavLink>
      </MobileNavMenu> */}
      <NavMenu>
        {menuData.map((item, index) => (
          item.link.startsWith('/') ?
            <NavLink to={item.link} key={index}>
              {item.title}
            </NavLink>
            : <NavLink as="a" href={item.link} key={index}>
              {item.title}
            </NavLink>
        ))}
      </NavMenu>
      <NavBtn>
        <Button primary="false" round="true" to="/#download-app-section">Baixar App</Button>
      </NavBtn>
    </Nav>
  )
}


export default Header

const Nav = styled.nav`
  background: transparent;
  height: 80px;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem calc((100vw - 1300px) / 2);
  z-index: 100;
  position: relative;
`

const NavLink = styled(Link)`
  color: #ffff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
`

// const Bars = styled(FaBars)`
//   display: none;
//   color: #fff;

//   @media screen and (max-width: 768px) {
//     display: block;
//     position: absolute;
//     top: 0;
//     right: 0;
//     transform: translate(-100%, 75%);
//     font-size: 1.8rem;
//     cursor: pointer;
//   }
// `

const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -48px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`

// const MobileNavMenu = styled.div`
//   display: none;

//   @media screen and (max-width: 768px) {
//     display: flex;
//     align-items: end;
//   }
// `

const NavBtn = styled.div`
  display: flex;
  align-items: center;
  margin-right: 24px;
`

